import whitelistData from './whitelist.json';

export class Whitelist {
  private static domains = new Set(whitelistData.legitimateDomains);
  private static keywords = whitelistData.legitimateKeywords;

  /**
   * Check if a domain is whitelisted (legitimate)
   */
  static isWhitelisted(domain: string): boolean {
    const normalized = domain.toLowerCase().replace(/^www\./, '');

    // Check exact match
    if (this.domains.has(normalized)) {
      return true;
    }

    // Check if domain ends with whitelisted domain (for subdomains)
    for (const whitelistedDomain of this.domains) {
      if (normalized.endsWith(`.${whitelistedDomain}`) || normalized === whitelistedDomain) {
        return true;
      }
    }

    return false;
  }

  /**
   * Check if URL contains legitimate keywords
   */
  static hasLegitimateKeywords(text: string): boolean {
    const lowerText = text.toLowerCase();
    return this.keywords.some(keyword => lowerText.includes(keyword.toLowerCase()));
  }

  /**
   * Extract domain from URL
   */
  static extractDomain(url: string): string {
    try {
      const urlObj = new URL(url);
      return urlObj.hostname.replace(/^www\./, '');
    } catch {
      return '';
    }
  }

  /**
   * Check if URL should be excluded from scanning
   */
  static shouldExclude(url: string, pageText?: string): boolean {
    const domain = this.extractDomain(url);

    if (this.isWhitelisted(domain)) {
      return true;
    }

    if (pageText && this.hasLegitimateKeywords(pageText)) {
      return true;
    }

    return false;
  }

  /**
   * Add custom domain to whitelist (runtime only, not persisted)
   */
  static addDomain(domain: string): void {
    this.domains.add(domain.toLowerCase().replace(/^www\./, ''));
  }

  /**
   * Get all whitelisted domains
   */
  static getDomains(): string[] {
    return Array.from(this.domains);
  }
}
